import React, { FC, PropsWithChildren, ReactNode, CSSProperties } from 'react';
import { View } from '@tarojs/components';
import { ButtonProps } from '@tarojs/components/types/Button';
import Loading from '../loading';
import Result from '../result';
import Toast from '../toast';

interface ILoadGeniusProps {
  status?: 'loading' | 'empty' | 'error' | 'content';
  refresh?: boolean;
  customLoading?: ReactNode;
  customError?: ReactNode;
  customEmpty?: ReactNode;
  contentClassName?: string;
  loadingClassName?: string;
  loadingStyle?: CSSProperties;
  errorClassName?: string;
  errorImageUrl?: string;
  errorTitle?: string;
  errorMessage?: string;
  errorButtonType?: keyof ButtonProps.type;
  errorButtonText?: string;
  onErrorButtonClick?: () => void;
  emptyClassName?: string;
  emptyImageUrl?: string;
  emptyText?: string;
  emptyButtonType?: keyof ButtonProps.type;
  emptyButtonText?: string;
  onEmptyButtonClick?: () => void;
}

const LoadGenius: FC<PropsWithChildren<ILoadGeniusProps>> = ({
  children,
  status = 'content',
  refresh = false,
  contentClassName = '',
  loadingClassName = '',
  loadingStyle = {},
  customLoading,
  customError,
  customEmpty,
  errorClassName = '',
  errorImageUrl = 'https://img.yifengx.com/ssm/yfjx/images/v0/load/ic_error.png',
  errorTitle,
  errorButtonText,
  errorButtonType,
  errorMessage,
  onErrorButtonClick,
  emptyClassName = '',
  emptyImageUrl = 'https://img.yifengx.com/ssm/yfjx/images/v0/load/ic_empty.png',
  emptyText = '暂无数据',
  emptyButtonText,
  emptyButtonType,
  onEmptyButtonClick,
}) => {
  return (
    <>
      {status === 'loading' &&
        (customLoading ? <View className={loadingClassName}>{customLoading}</View> : <Loading className={loadingClassName} style={loadingStyle} />)}
      {status === 'error' &&
        (customError ? (
          <View className={errorClassName}>{customError}</View>
        ) : (
          <Result
            className={errorClassName}
            imageUrl={errorImageUrl}
            title={errorTitle}
            message={errorMessage}
            buttonType={errorButtonType}
            buttonText={errorButtonText}
            onButtonClick={onErrorButtonClick}
          />
        ))}
      {status === 'empty' &&
        (customEmpty ? (
          <View className={emptyClassName}>{customEmpty}</View>
        ) : (
          <Result
            className={emptyClassName}
            imageUrl={emptyImageUrl}
            message={emptyText}
            buttonType={emptyButtonType}
            buttonText={emptyButtonText}
            onButtonClick={onEmptyButtonClick}
          />
        ))}
      {status === 'content' && (
        <View className={contentClassName}>
          {children}
          <Toast text="正在更新" isOpened={refresh} hasMask />
        </View>
      )}
    </>
  );
};

export default LoadGenius;
